module.exports = __webpack_public_path__ + "img/logo-w.e1a84ba9.png";